import { getStoreId } from "$/hooks/use-store-information.ts"
import statsQueries from "$/lib/queries/stats-queries.ts"
import { requireAdmin } from "$/lib/require-admin.ts"
import { requireStoreFeature } from "$/lib/require-store-feature.ts"
import { STORE_FEATURE } from "@repo/common"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/price-simulator/")({
  loader: async ({ context: { queryClient } }) => {
    await requireAdmin(queryClient)
    await requireStoreFeature(queryClient, STORE_FEATURE.INSIGHTS)
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(statsQueries.priceSimulation(storeId, {}))
    }

    return {
      crumb: "alfred.pages.priceSimulator.crumbs.priceSimulator",
    }
  },
})
